import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { TooltipContent } from "../tooltip/content";
import { VNode } from 'intact-vue';
import template from "./content.vdt";
var typeDefs = {
  type: ['info', 'error', 'success', 'warning'],
  title: [String, Number, VNode, Array],
  content: [String, Number, VNode, Array]
};
export var PopoverContent = /*#__PURE__*/function (_TooltipContent) {
  _inheritsLoose(PopoverContent, _TooltipContent);
  function PopoverContent() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _TooltipContent.call.apply(_TooltipContent, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    // don't check children
    _this.isEmptyChildren = false;
    return _this;
  }
  return PopoverContent;
}(TooltipContent);
PopoverContent.template = template;
PopoverContent.typeDefs = typeDefs;